import { mapDTO } from '@twistezo/ts-dto-mapper'
import _ from 'lodash'

import { Workspace } from 'features/workspace'
import { Ability } from 'providers/casl'
import { fieldsToOmit } from 'providers/tanstack-query/utils'
import { floatPercentToDTO } from 'utils/number'
import { AddYieldbirdSchema } from '../../../schemas/addSchema'
import { Variables as VariablesDTO } from './types'

type From = AddYieldbirdSchema & { workspaceId: Workspace['id'] }
type To = VariablesDTO

export const toDTO = (from: From, ability: Ability): To =>
  mapDTO<From, To>({ from }).transform((data: From): To => {
    const { bidCpmAdjustment, bidderId, bidderSid, consentMode, priority, workspaceId } = data

    const constantFields: Pick<To, 'bidderId' | 'priority' | 'workspaceId'> = {
      bidderId: bidderId.value,
      priority,
      workspaceId,
    }

    const variableFields: Pick<To, 'bidCpmAdjustment' | 'bidderSid' | 'consentMode'> = {
      bidCpmAdjustment: floatPercentToDTO(bidCpmAdjustment),
      bidderSid,
      consentMode,
    }

    return {
      ...constantFields,

      ..._.omit(
        variableFields,
        fieldsToOmit({
          bidCpmAdjustment: ability.cannot(
            'update',
            'GlobalSetupField-prebid-bidders-yieldbird-bidCpmAdjustment',
          ),
          bidderSid: ability.cannot(
            'update',
            'GlobalSetupField-prebid-bidders-yieldbird-bidderSid',
          ),
          consentMode: ability.cannot(
            'update',
            'GlobalSetupField-prebid-bidders-yieldbird-consentMode',
          ),
        }),
      ),
    }
  })
